// extracted by mini-css-extract-plugin
export default {"display-name":"SignedIn_display-name__csXYC"};